<template>
  <div :style="{left: showPos.left, top: showPos.top}" class="tdt-mini-map">
    <div class="map-toolbar">
      <el-input v-model="address"
                size="mini"
                placeholder="请输入地址"
                style="width: 160px;"
                clearable
                @keyup.enter.native="doSearch" />
      <el-button size="mini" type="primary" icon="el-icon-search" @click="doSearch"></el-button>
      <el-button size="mini" icon="el-icon-check" @click="confirm"></el-button>
      <el-button size="mini" icon="el-icon-close" @click="closeMap"></el-button>
    </div>

    <div v-if="showResults" class="search-results-panel">
      <div class="results-header">
        <span>搜索结果</span>
        <el-button size="mini" type="text" @click="showResults = false">返回地图</el-button>
      </div>
      <div v-if="searchLoading" class="results-loading">搜索中...</div>
      <div v-else-if="searchResults.length === 0" class="results-empty">无结果</div>
      <ul v-else class="results-list">
        <li v-for="(item, idx) in searchResults"
            :key="idx"
            class="results-item"
            @click="selectResult(item)">
          {{ item.value }}
        </li>
      </ul>
    </div>

    <div v-show="!showResults" ref="mapContainer" class="map-container">
      <div class="center-marker"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TdtMiniMap',
  props: {
    apiKey: { type: String, default: '52eda5d646e55bc9ba09a7b6ec607bed' },
    showPos: { type: Object, default: function() { return { left: '0px', top: '0px' } } },
    mapcenter: { type: Object, default: function() { return { lng: 0, lat: 0 } } }
  },
  data: function() {
    return {
      map: null,
      marker: null,
      address: '',
      zoom: 10,
      showResults: false,
      searchLoading: false,
      searchResults: [],
      searchRequestId: 0
    }
  },
  mounted: function() {
    this.loadTiandituScript().then(function() {
      return this.initMap()
    }.bind(this)).catch(function(err) { console.error(err) })
  },
  beforeDestroy: function() {
    if (this.map) {
      try { this.map.destroy && this.map.destroy() } catch (e) {}
      this.map = null
    }
  },
  methods: {
    loadTiandituScript: function() {
      var vm = this
      return new Promise(function(resolve, reject) {
        if (window.T) return resolve()
        var src = 'https://api.tianditu.gov.cn/api?v=4.0&tk=' + vm.apiKey
        var s = document.createElement('script')
        s.src = src
        s.onload = function() { resolve() }
        s.onerror = function() { reject(new Error('load tianditu script failed')) }
        document.head.appendChild(s)
      })
    },
    initMap: function() {
      try {
        var T = window.T
        this.map = new T.Map(this.$refs.mapContainer)

        if (this.mapcenter && this.mapcenter.lng !== 0 && this.mapcenter.lat !== 0) {
          this.map.centerAndZoom(new T.LngLat(this.mapcenter.lng, this.mapcenter.lat), this.zoom + 3)
        } else {
          this.map.centerAndZoom(new T.LngLat(116.407396, 39.904200), this.zoom)
        }

        if (T.Control && T.Control.Navigation) this.map.addControl(new T.Control.Navigation())
        else if (T.NavigationControl) this.map.addControl(new T.NavigationControl())

        if (T.Control && T.Control.Scale) this.map.addControl(new T.Control.Scale())
        else if (T.ScaleControl) this.map.addControl(new T.ScaleControl())

        var center = this.map.getCenter ? this.map.getCenter() : { lng: this.mapcenter.lng || 116.407396, lat: this.mapcenter.lat || 39.904200 }
        var initLng = (this.mapcenter && this.mapcenter.lng !== 0) ? this.mapcenter.lng : (center.lng || (center.getLng && center.getLng()))
        var initLat = (this.mapcenter && this.mapcenter.lat !== 0) ? this.mapcenter.lat : (center.lat || (center.getLat && center.getLat()))

        this.marker = new T.Marker(new T.LngLat(initLng, initLat), { draggable: true })
        if (this.map.addOverLay) this.map.addOverLay(this.marker)
        else if (this.map.addOverlay) this.map.addOverlay(this.marker)

        var vm = this

        if (this.marker.addEventListener) {
          this.marker.addEventListener('dragend', function() {
            var p = vm.marker.getPosition ? vm.marker.getPosition() : (vm.marker.getLngLat ? vm.marker.getLngLat() : null)
            if (p) {
              var lng = p.lng || p.lon || (p.getLng ? p.getLng() : null)
              var lat = p.lat || (p.getLat ? p.getLat() : null)
              if (lng != null && lat != null) vm.map.centerAndZoom(new T.LngLat(lng, lat), vm.map.getZoom ? vm.map.getZoom() : vm.zoom)
            }
          })
        } else if (window.T && window.T.event && window.T.event.addListener) {
          window.T.event.addListener(this.marker, 'dragend', function(e) {
            if (e && e.target) {
              var p = e.target.getPosition ? e.target.getPosition() : (e.target.getLatLng ? e.target.getLatLng() : (e.target.getLngLat ? e.target.getLngLat() : null))
              if (p) {
                vm.map.centerAndZoom(new T.LngLat(p.lng || p.lon || p.x, p.lat || p.y), vm.map.getZoom ? vm.map.getZoom() : vm.zoom)
              }
            }
          })
        }

        if (this.map.addEventListener) {
          this.map.addEventListener('click', function(e) {
            var lng, lat
            if (e && e.lnglat) {
              lng = e.lnglat.lng || e.lnglat.lon || (e.lnglat.getLng && e.lnglat.getLng())
              lat = e.lnglat.lat || (e.lnglat.getLat && e.lnglat.getLat())
            } else if (e && e.point) {
              lng = e.point.lng || e.point.lon || (e.point.getLng && e.point.getLng())
              lat = e.point.lat || (e.point.getLat && e.point.getLat())
            }
            if (lng != null && lat != null) {
              var newPos = new T.LngLat(lng, lat)
              if (vm.marker.setPosition) {
                vm.marker.setPosition(newPos)
              } else if (vm.marker.setLatLng) {
                vm.marker.setLatLng(newPos)
              } else if (vm.marker.setLngLat) {
                vm.marker.setLngLat(newPos)
              }
              vm.map.centerAndZoom(newPos, vm.map.getZoom ? vm.map.getZoom() : vm.zoom)
            }
          })
        } else if (window.T && window.T.event && window.T.event.addListener) {
          window.T.event.addListener(this.map, 'click', function(e) {
            if (e && e.lnglat) {
              var newPos = new T.LngLat(e.lnglat.lng || e.lnglat.lon, e.lnglat.lat)
              if (vm.marker.setPosition) {
                vm.marker.setPosition(newPos)
              } else if (vm.marker.setLatLng) {
                vm.marker.setLatLng(newPos)
              } else if (vm.marker.setLngLat) {
                vm.marker.setLngLat(newPos)
              }
              vm.map.centerAndZoom(newPos, vm.map.getZoom ? vm.map.getZoom() : vm.zoom)
            }
          })
        }

      } catch (ex) {
        console.error('initMap error', ex)
      }
    },
    doSearch: function() {
      var kw = (this.address || '').trim()
      if (!kw) return

      this.showResults = true
      this.searchLoading = true
      this.searchResults = []

      var requestId = ++this.searchRequestId
      var vm = this
      var finish = function(suggestions) {
        if (requestId !== vm.searchRequestId) return
        vm.searchLoading = false
        vm.searchResults = suggestions || []
      }

      var T = window.T
      if (T && T.LocalSearch) {
        try {
          var localSearch = new T.LocalSearch(this.map, {
            pageCapacity: 10,
            onSearchComplete: function(results) {
              if (requestId !== vm.searchRequestId) return
              let suggestions = []
              try {
                if (!results) return finish([])
                let num = results.pois && results.pois.length ? results.pois.length : 0
                for (let i = 0; i < num; i++) {
                  let poi = results.pois[i]
                  if (!poi) continue
                  let name = (poi.name || poi.title || '').trim()
                  let pt = poi.lonlat
                  if (pt) {
                    let lng, lat
                    if (typeof pt === 'string') {
                      let parts = pt.split(',')
                      lng = parseFloat(parts[0])
                      lat = parseFloat(parts[1])
                    } else {
                      lng = pt.lng != null ? pt.lng : (pt.lon != null ? pt.lon : (pt.x != null ? pt.x : (pt.getLng ? pt.getLng() : null)))
                      lat = pt.lat != null ? pt.lat : (pt.y != null ? pt.y : (pt.getLat ? pt.getLat() : null))
                    }
                    if (!isNaN(lng) && !isNaN(lat)) {
                      suggestions.push({ value: name, coord: { lng: lng, lat: lat } })
                    } else {
                      suggestions.push({ value: name })
                    }
                  } else {
                    suggestions.push({ value: name })
                  }
                }
                finish(suggestions)
              } catch (e) { finish([]) }
            }
          })
          localSearch.search(kw)
          return
        } catch (e) {
          console.warn('LocalSearch failed, fallback to REST', e)
        }
      }

      var postObj = {
        keyWord: kw,
        level: '12',
        count: 10,
        page: 1,
        mapBound: '',
        queryBy: 'keyword'
      }
      var url = 'https://api.tianditu.gov.cn/search?postStr=' + encodeURIComponent(JSON.stringify(postObj)) + '&type=query&tk=' + this.apiKey
      fetch(url).then(function(r) { return r.json() }).then(function(data) {
        if (requestId !== vm.searchRequestId) return
        var suggestions = []
        if (data && data.result && data.result.length) {
          data.result.forEach(function(item) {
            var name = item.name || item.displayName || (item.address || '')
            var x = item.x || item.lon || item.longitude
            var y = item.y || item.lat || item.latitude
            if (x != null && y != null) suggestions.push({ value: name, coord: { lng: parseFloat(x), lat: parseFloat(y) } })
            else suggestions.push({ value: name })
          })
        }
        finish(suggestions)
      }).catch(function() { finish([]) })
    },
    selectResult: function(item) {
      if (item && item.coord && this.map && this.marker) {
        var T = window.T
        var newPos = new T.LngLat(item.coord.lng, item.coord.lat)
        if (this.marker.setPosition) {
          this.marker.setPosition(newPos)
        } else if (this.marker.setLatLng) {
          this.marker.setLatLng(newPos)
        } else if (this.marker.setLngLat) {
          this.marker.setLngLat(newPos)
        }
        this.map.centerAndZoom(newPos, this.zoom + 5)
      }
      this.showResults = false
    },
    confirm: function() {
      if (!this.map) return
      var lng = 0, lat = 0
      if (this.marker && (this.marker.getPosition || this.marker.getLatLng || this.marker.getLngLat)) {
        var p = this.marker.getPosition ? this.marker.getPosition() : (this.marker.getLatLng ? this.marker.getLatLng() : (this.marker.getLngLat ? this.marker.getLngLat() : null))
        if (p) {
          lng = p.lng || p.lon || p.x || (p.getLng ? p.getLng() : 0)
          lat = p.lat || p.y || (p.getLat ? p.getLat() : 0)
        }
      }
        var center = this.map.getCenter ? this.map.getCenter() : null
        if (center) {
          lng = center.lng || (center.getLng ? center.getLng() : 0)
          lat = center.lat || (center.getLat ? center.getLat() : 0)
        }

      this.$emit('getMapClickCoordinate', { lng: lng, lat: lat })
      this.closeMap()
    },
    closeMap: function() {
      this.$emit('closemap', false)
    }
  }
}
</script>

<style scoped>
.tdt-mini-map {
  position: absolute;
  width: 600px;
  height: 400px;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  overflow: hidden;
}
.map-toolbar {
  display: flex;
  align-items: center;
  padding: 6px;
  background: rgba(255,255,255,0.95);
  z-index: 10;
}
.map-toolbar .el-button + .el-button {
  margin-left: 0;
}
.map-container {
  position: absolute;
  left: 0;
  top: 36px;
  right: 0;
  bottom: 0;
}
.center-marker {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -100%);
  width: 24px;
  height: 24px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="%23e74c3c"/></svg>') no-repeat center;
  pointer-events: none;
  z-index: 20;
}
.search-results-panel {
  position: absolute;
  left: 0;
  top: 36px;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 15;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  border-bottom: 1px solid #eee;
  font-size: 13px;
  font-weight: 500;
}
.results-loading,
.results-empty {
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 13px;
}
.results-list {
  flex: 1;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
}
.results-item {
  padding: 8px 10px;
  font-size: 13px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
}
.results-item:hover {
  background: #f0f7ff;
}
</style>
